export const minecraft1214 = {
  version: '1.21.4',
  title: 'Garden Awakens',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Minecraft_TheGardenAwakens_DotNet_1280x768.jpg',
  releases: [
    {
      id: "70bU5Pqd",
      version: "1.0.4",
      date: "May 12, 2025",
      changelog: "Última versión estable para Minecraft 1.21.4 con todas las características",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21.4",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project/files/7417724",
      isBeta: false
    },
    {
      id: "80cV6Qre",
      version: "1.0.3",
      date: "Feb 9, 2025",
      changelog: "Mejoras de rendimiento y corrección de errores",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.3-1.21.4",
      curseforgeUrl: "",
      isBeta: false
    },
    {
      id: "90dW7Rsf",
      version: "1.0.2",
      date: "Jan 9, 2025",
      changelog: "Actualización de mods y optimizaciones",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.2-1.21.4",
      curseforgeUrl: "",
      isBeta: false
    },
    {
      id: "10eX8Stg",
      version: "1.0.1",
      date: "Jan 9, 2025",
      changelog: "Primera actualización con correcciones importantes",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.1-1.21.4",
      curseforgeUrl: "",
      isBeta: false
    },
    {
      id: "2A3CX5em",
      version: "1.0.0",
      date: "Jan 9, 2025",
      changelog: "Primera versión estable para Minecraft 1.21.4 y del modpack entero,con errores",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.0-1.21.4",
      curseforgeUrl: "",
      isBeta: false
    }
  ]
};
